import { getOrgTermsContent } from '../content/utils.js';
import { momentToDateString } from '../lib/utils.js';

export const NO_PORTFOLIO = 'no_portfolio';

// Order follows the 2×3 grid of the design (left to right, top to bottom)
export const DUPLICATION_SECTIONS = [
  { value: 'change_strategy', label: 'Change strategy & milestones' },
  { value: 'stakeholders', label: 'Stakeholders' },
  { value: 'change_impacts', label: 'Change impacts & tasks' },
  { value: 'activities', label: 'Activities' },
  { value: 'linked_files', label: 'Linked files' },
  { value: 'team_access', label: 'Team access (roles)' },
];

export const DUPLICATION_INITIATIVE_TYPES = [
  { value: 'communication', label: 'Communication' },
  { value: 'readiness', label: 'Readiness' },
  { value: 'training', label: 'Training' },
  { value: 'sustainment', label: 'Sustainment' },
];

export const ALL_SECTIONS = DUPLICATION_SECTIONS.map(({ value }) => value);
export const ALL_INITIATIVE_TYPES = DUPLICATION_INITIATIVE_TYPES.map(
  ({ value }) => value
);

// Org terms are applied to the template only, so user content (names) is never rewritten.
export const duplicationText = (key, params = {}) =>
  Object.entries(params).reduce(
    (text, [name, value]) => text.replace(`{${name}}`, value),
    getOrgTermsContent(`duplicateProject.${key}`)
  );

export const joinWithAnd = (items) =>
  items.length < 2
    ? items.join('')
    : `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;

// "Nothing selected" replaces every other warning.
export const getDuplicationWarnings = ({ sections, initiativeTypes }) => {
  if (!sections.length && !initiativeTypes.length) {
    return [duplicationText('warnings.nothingSelected')];
  }

  const has = (value) => sections.includes(value);
  const warnings = [];

  if (
    !has('stakeholders') &&
    (has('change_impacts') || initiativeTypes.length)
  ) {
    warnings.push(duplicationText('warnings.stakeholders'));
  }

  if (!has('team_access'))
    warnings.push(duplicationText('warnings.teamAccess'));

  const cleared = DUPLICATION_INITIATIVE_TYPES.filter(
    ({ value }) => !initiativeTypes.includes(value)
  );

  if (cleared.length === DUPLICATION_INITIATIVE_TYPES.length) {
    warnings.push(duplicationText('warnings.allInitiatives'));
  } else if (cleared.length) {
    warnings.push(
      duplicationText('warnings.someInitiatives', {
        types: joinWithAnd(cleared.map(({ label }) => label)),
      })
    );
  }

  return warnings;
};

// A blank portfolio_id means "No portfolio" for the backend.
export const buildDuplicatePayload = (values) => ({
  project: {
    name: values.name.trim(),
    startDate: momentToDateString(values.startDate),
    endDate: momentToDateString(values.endDate),
    portfolioId:
      values.portfolioId === NO_PORTFOLIO ? '' : Number(values.portfolioId),
  },
  sections: values.sections,
  initiativeTypes: values.initiativeTypes,
});
